import axios from "axios";

const API_BASE_URL =
  process.env.REACT_APP_API_URL || "http://31.97.50.160:5001/api";
// const API_BASE_URL =
// process.env.REACT_APP_API_URL || "http://localhost:5001/api";
// Base URL without /api for admin endpoints
const USER_BASE_URL =
  process.env.REACT_APP_USER_API_URL ||
  "https://backend.hunarmandpunjab.org.pk";

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Add token to requests
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Handle token expiration
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem("token");
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

// PDF Generation API
export const generateUserPDF = async (
  userId: string,
  adminApiKey: string,
  userInfo?: { fullName?: string; rollNumber?: string; email?: string }
) => {
  try {
    const token = localStorage.getItem("token");
    const userObj = JSON.parse(localStorage.getItem("user") || "{}");
    const currentAdminUser = userObj.username || "admin";

    const response = await axios.post(
      `${USER_BASE_URL}/api/admin/generate-pdf`,
      { userId, adminUser: currentAdminUser },
      {
        headers: {
          "X-API-Key": adminApiKey || "123456789",
          "Authorization": token ? `Bearer ${token}` : "",
          "Content-Type": "application/json",
        },
      }
    );

    // Save AuditLog for PDF generation
    try {
      const studentLabel = userInfo?.fullName
        ? `${userInfo.fullName}${userInfo.rollNumber ? ` (${userInfo.rollNumber})` : ""}`
        : userId;

      await api.post("/audit-logs/log", {
        entityType: "challan",
        entityId: userId,
        action: "generate-pdf",
        changes: {
          userId: { old: null, new: userId },
          fullName: { old: null, new: userInfo?.fullName || null },
          rollNumber: { old: null, new: userInfo?.rollNumber || null },
        },
        adminUser: currentAdminUser,
        reason: `Admin (${currentAdminUser}) generated PDF challan for student: ${studentLabel}`,
      });
    } catch (auditErr) {
      console.error("Failed to save audit log for PDF generation:", auditErr);
    }

    return response;
  } catch (error) {
    throw error;
  }
};

export const getAdmitCards = async (venue?: string, search?: string) => {
  const params = new URLSearchParams();
  if (venue) params.append("venue", venue);
  if (search) params.append("search", search);

  const response = await api.get(`/admit-card/admin/all?${params.toString()}`);
  return response.data;
};

export const getSettings = async () => {
  const response = await api.get("/settings/all");
  return response.data;
};

export const updateSetting = async (name: string, data: any) => {
  const response = await api.put(`/settings/${name}`, data);
  return response.data;
};

export const exportAdmitCardsCSV = async (venue?: string) => {
  const token = localStorage.getItem("token");
  const url = `${API_BASE_URL}/admit-card/admin/export?${
    venue ? `venue=${venue}&` : ""
  }token=${token}`;
  window.open(url, "_blank");
};

export const deleteAdmitCard = async (id: string) => {
  const response = await api.delete(`/admit-card/admin/${id}`);
  return response.data;
};

export const bulkDeleteAdmitCards = async (ids: string[]) => {
  const response = await api.post("/admit-card/admin/bulk-delete", { ids });
  return response.data;
};

// User deletion
export const deleteUser = async (id: string) => {
  const response = await api.delete(`/users/${id}`);
  return response.data;
};

export const bulkDeleteUsers = async (ids: string[]) => {
  const response = await api.post("/users/bulk-delete", { ids });
  return response.data;
};

export const changeUserPassword = async (id: string, newPassword: string, reason: string) => {
  const response = await api.put(`/users/${id}/change-password`, { newPassword, reason });
  return response.data;
};

export const updateUser = async (id: string, data: { fullName: string; reason: string }) => {
  const response = await api.put(`/users/${id}`, data);
  return response.data;
};

// Scholarship deletion
export const deleteScholarship = async (id: string) => {
  const response = await api.delete(`/scholarships/${id}`);
  return response.data;
};

export const bulkDeleteScholarships = async (ids: string[]) => {
  const response = await api.post("/scholarships/bulk-delete", { ids });
  return response.data;
};

// Onsite Students
export const getOnsiteStudents = async (
  page: number,
  limit: number,
  search?: string,
  courseApplied?: string,
  city?: string,
  qualification?: string,
  gender?: string,
  challanPaid?: string,
  noChallan?: string,
  startDate?: string,
  endDate?: string
) => {
  const params = new URLSearchParams();
  params.append("page", page.toString());
  params.append("limit", limit.toString());
  if (search) params.append("search", search);
  if (courseApplied) params.append("courseApplied", courseApplied);
  if (city) params.append("city", city);
  if (qualification) params.append("qualification", qualification);
  if (gender) params.append("gender", gender);
  if (challanPaid) params.append("challanPaid", challanPaid);
  if (noChallan) params.append("noChallan", noChallan);
  if (startDate) params.append("startDate", startDate);
  if (endDate) params.append("endDate", endDate);

  const response = await api.get(`/users/onsite?${params.toString()}`);
  return response.data;
};

// Onsite Challans
export const getOnsiteChallans = async (
  page: number,
  limit: number,
  search?: string,
  status?: string,
  startDate?: string,
  endDate?: string,
  minAmount?: string,
  maxAmount?: string,
  submitDate?: string
) => {
  const params = new URLSearchParams();
  params.append("page", page.toString());
  params.append("limit", limit.toString());
  if (search) params.append("search", search);
  if (status) params.append("status", status);
  if (startDate) params.append("startDate", startDate);
  if (endDate) params.append("endDate", endDate);
  if (minAmount) params.append("minAmount", minAmount);
  if (maxAmount) params.append("maxAmount", maxAmount);
  if (submitDate) params.append("submitDate", submitDate);

  const response = await api.get(`/challans/onsite?${params.toString()}`);
  return response.data;
};

export const deleteOnsiteChallan = async (id: string) => {
  const response = await api.delete(`/challans/onsite/${id}`);
  return response.data;
};

export const getUserChallans = async (userId: string) => {
  const response = await api.get(`/challans/user/${userId}`);
  return response.data;
};

export const deleteChallan = async (id: string, reason?: string) => {
  const response = await api.delete(`/challans/${id}`, { data: { reason } });
  return response.data;
};

export const bulkDeleteChallans = async (ids: string[], reason?: string) => {
  const response = await api.post("/challans/bulk-delete", { ids, reason });
  return response.data;
};

export const regenerateChallan = async (id: string, reason?: string) => {
  const response = await api.post(`/challans/regenerate/${id}`, { reason });
  return response.data;
};

// Onsite extra APIs
export const deleteOnsiteStudent = async (id: string) => {
  const response = await api.delete(`/users/onsite/${id}`);
  return response.data;
};

export const bulkDeleteOnsiteStudents = async (ids: string[]) => {
  const response = await api.post("/users/onsite/bulk-delete", { ids });
  return response.data;
};

export const changeOnsiteUserPassword = async (id: string, newPassword: string, reason: string) => {
  const response = await api.put(`/users/onsite/${id}/change-password`, { newPassword, reason });
  return response.data;
};

export const updateOnsiteUser = async (id: string, data: { fullName: string; reason: string }) => {
  const response = await api.put(`/users/onsite/${id}`, data);
  return response.data;
};

export const bulkDeleteOnsiteChallans = async (ids: string[]) => {
  const response = await api.post("/challans/onsite/bulk-delete", { ids });
  return response.data;
};

export const getOnsiteStudentChallans = async (studentId: string) => {
  const response = await api.get(`/challans/onsite/student/${studentId}`);
  return response.data;
};

export const generateOnsiteChallan = async (studentId: string) => {
  const response = await api.post(`/challans/onsite/generate`, { studentId });
  return response.data;
};

export const exportOnsiteChallansCSV = async (params: any) => {
  const token = localStorage.getItem("token");
  const urlParams = new URLSearchParams();
  Object.keys(params).forEach((key) => {
    if (params[key] !== undefined && params[key] !== null && params[key] !== "") {
      urlParams.append(key, params[key].toString());
    }
  });
  urlParams.append("token", token || "");
  const url = `${API_BASE_URL}/challans/onsite/download?${urlParams.toString()}`;
  window.open(url, "_blank");
};

export const createAdminUser = async (data: any) => {
  const response = await api.post("/admin/users/create", data);
  return response.data;
};

// Admin Account Management (SuperAdmin)
export const getAdmins = async () => {
  const response = await api.get("/admins");
  return response.data;
};

export const createAdminAccount = async (data: {
  username: string;
  password: string;
  fullName?: string;
  email?: string;
}) => {
  const response = await api.post("/admins", data);
  return response.data;
};

export const deleteAdminAccount = async (id: string) => {
  const response = await api.delete(`/admins/${id}`);
  return response.data;
};

// Email Campaigns
export const getEmailAccounts = async () => {
  const response = await api.get("/emails/accounts");
  return response.data;
};

export const sendEmailCampaign = async (data: {
  senderEmail: string;
  subjectTemplate: string;
  bodyTemplate: string;
  students: any[];
}) => {
  const response = await api.post("/emails/send", data);
  return response.data;
};

export const sendTestEmail = async (data: {
  senderEmail: string;
  subjectTemplate: string;
  bodyTemplate: string;
  testEmail: string;
}) => {
  const response = await api.post("/emails/test", data);
  return response.data;
};


// Email Templates CRUD
export const getEmailTemplates = async () => {
  const response = await api.get("/emails/templates");
  return response.data;
};

export const createEmailTemplate = async (data: { name: string; subject: string; body: string }) => {
  const response = await api.post("/emails/templates", data);
  return response.data;
};

export const updateEmailTemplate = async (id: string, data: { name: string; subject: string; body: string }) => {
  const response = await api.put(`/emails/templates/${id}`, data);
  return response.data;
};

export const deleteEmailTemplate = async (id: string) => {
  const response = await api.delete(`/emails/templates/${id}`);
  return response.data;
};

export default api;
